<template>
  <div>
    <template v-if="orderGroups.length">
      <div class="mb-4" v-for="(orderGroup, index) in orderGroups" :key="`orderGroup-${index}`">
        <h5 class="mb-3">{{ orderGroup.address.address1 }}, {{ orderGroup.address.address2 }} {{ orderGroup.address.city }}, {{ orderGroup.address.provinceCode }} {{ orderGroup.address.zip }}, {{ orderGroup.address.countryCode }}</h5>
        <vs-table ref="table" class="pb-5" :data="orderGroup.orders">
          <template slot="thead">
            <vs-th v-for="(header, index) in headers" :key="`header-${index}`" >
              {{ header }}
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody v-for="(order, index) in data" :data="orderGroup.orders" :key="index" @click="$router.push(`/orders/${order._id}`)">
              <vs-tr class="cursor-pointer">
                <vs-td>
                  <p class="font-medium truncate">{{ order.orderNumber }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ moment(order.shipTime).format('MM-DD-YYYY HH:mm A') }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ order.shippingAddress.firstName }} {{ order.shippingAddress.lastName }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ order.status.split('_').join(' ') }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ order.fulfillmentType }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </template>
    <div v-else>
      <h5>No orders found with matching addresses</h5>
    </div>
  </div>
</template>

<script>
import api from "@/http/api";
import moment from "moment";

export default {
  data() {
    return {
      orderGroups: [],
      headers: ['Order Number', 'Process Date', 'Customer','Status', 'Fulfillment']
    }
  },
  mounted() {
    this.fetch();
  },
  methods:{
    moment:moment,
    async fetch(){
      this.$vs.loading();
      this.orderGroups = await api.groupOrderByAddress();
      this.$vs.loading.close();
    }
  }
}
</script>
